var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.1 69.9"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 31.2c-5.2 0-9.7 1.9-13.4 5.7C1.8 40.7 0 45.3 0 50.6s1.8 9.9 5.6 13.6c3.7 3.8 8.2 5.7 13.4 5.7s9.8-1.9 13.6-5.7c3.7-3.7 5.6-8.3 5.6-13.6s-1.9-9.9-5.6-13.7c-3.8-3.8-8.3-5.7-13.6-5.7zm7.2 26.5c-1.9 2-4.3 3-7.1 3-2.7 0-5.1-1-7.1-3-1.9-2-3-4.4-3-7.2 0-2.9 1.1-5.3 3-7.2 1.9-2 4.3-3 7.1-2.9 2.8-.1 5.2.9 7.2 2.9 1.9 1.9 2.8 4.3 2.9 7.2-.1 2.8-1.1 5.2-3 7.2z",
    className: "loading-circle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1 4.6 34 26.8l5.8 5.8 22.1-22.2z",
    className: "loading-second"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0h8.2v23.8H16z",
    className: "loading-first"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8 41.8h24.3V50H43.8z",
    className: "loading-third"
  }))));
};
export default SvgLogoIcon;